/* eslint-disable no-invalid-this */

/**
 * Authenticates a user using the Cognito flow.
 *
 * For Cognito, the credentials should include username and password.
 * The flow obtains a Cognito token (via this.cognitoAuthenticator.authenticate)
 * and then calls fetchNeonApiTokenAndUser with the Cognito token and optional two-factor code.
 *
 * @param {Object} credentials - Expected to include username, password, and optionally twoFactorAuthenticationCode.
 * @returns {Promise<Object>} - Resolves with the authenticated user object.
 */
export function authenticate(credentials) {
    return this.cognitoAuthenticator.authenticate(credentials)
        .then(cognitoToken => this.fetchNeonApiTokenAndUser(cognitoToken, credentials.twoFactorAuthenticationCode))
        .catch(error => {
            this.logger.error({
                message: 'Unsuccessful neon API token exchange (Cognito)',
                error,
                component: 'neonAuth'
            });
            return Promise.reject(error);
        });
}
